import { writable } from "svelte/store";

export const version = "v1.9";

// export const baseUrl = "api.localhost"
// export const baseUrl = "api.test1.skyline.uavionix.com";
// export const baseUrl = "api.staging.skyline.uavionix.com"
// export const baseUrl = "api.npuasts-test.skyline.uavionix.com"
// export const protocol = "https:";
// export const protocol = ""

// export const baseUrl = "localhost"
// export const protocol = window.location.protocol;
// export const authUrl = "localhost:9001";
export const baseUrl = "api." + window.location.host
export const protocol = window.location.protocol;
export const authUrl = "auth.services.uavionix.com/v1";

export const toolboxEnabled = writable(false);
export const enablePi = writable(false);
export const devModeEnabled = writable(false);

export const targetEmitTypeString = [
  "No info",
  "Light",
  "Small",
  "Large",
  "High-vortex large",
  "Heavy",
  "Highly maneuverable",
  "Rotocraft",
  "Unassigned",
  "Glider",
  "Lighter than air",
  "Parachute",
  "Ultralight",
  "Unassigned2",
  "UAV",
  "Space",
  "Unassigned",
  "Emergency surface",
  "Service surface",
  "Point obstacle",
];

export const failCodeMessage = [
  "Timeout",
  "Link is Expired",
  "Configuration Error",
  "Version mismatch",
  "Invalid option",
  "Max",
  "Unknown",
  "Timeout connecting to the remote ARS",
  "Timeout waiting for a GRS to connect",
  "Timeout waiting for the feed connection",
  "Invalid GCS config",
];

export const usaBounds = [
  [17.929556, -188.90491],
  [71.351633, -65.626797],
];
